import { adminMenuItems } from '@/router/adminMenu';

export const useAdminMenu = () => {
  return { menuItems: adminMenuItems };
};
